import useAuth from '@app/auth/use-auth';
import GuideLayout from '@shared/components/guide-layout';
import { useEffect } from 'react';
import { generatePath, useNavigate } from 'react-router-dom';
import { ccfRoutes } from '../ccf-routes';

export default function CCFGuideLayout() {
  const navigate = useNavigate();
  const { user } = useAuth();

  useEffect(() => {
    if (!user?.organizationReportingStartingDate) {
      navigate(generatePath(ccfRoutes.REPORTING_PERIOD));
    }
  }, [navigate, user?.organizationReportingStartingDate]);

  return (
    <GuideLayout pageName="CCF guide" onClosePath={ccfRoutes.COMPANY_REPORTS} />
  );
}
